export default __webpack_public_path__ + "static/media/forms.fa241f2a.svg";